exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adjustMarginForHeader[data-v-844667f8]{margin:55px 0 -55px 0}", ""]);

// exports
